var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconExitFullscreen = function SvgIconExitFullscreen(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.25 4.58 14.5 8.33V5.322h-1.68v5.86h5.86v-1.68h-3.008l3.75-3.75zM5.32 12.822v1.68h3.008l-3.75 3.75 1.172 1.172 3.75-3.75v3.008h1.68v-5.86z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconExitFullscreen);
export { ForwardRef as ReactComponent };